export const login = {
  hi: '¡Qué bueno volverte a ver!',
  email: 'E-mail',
  password: 'Contraseña',
  logIn: 'Entrar',
  iForgotMyPassword: 'Olvidé mi contraseña',
  iDontHaveAnAccount: '¿Eres nuevo por aquí?',
  signUpNow: 'Registrate ahora',
  or: 'O ingresa tus datos',
  loginWithFacebook: 'Continúa con Facebook',
}

export const signup = {
  termsPart1: 'Al entrar aceptas los ',
  termsPart2: 'Términos y condiciones de uso',
  termsPart3: ' y las ',
  termsPart4: 'Políticas de privacidad',
  termsPart5: ' de Space Guru.',
  welcome: '¡Bienvenido a Space Guru!',
  labelName: 'Nombre',
  labelLastName: 'Apellido',
  labelEmail: 'E-mail',
  labelPassword: 'Contraseña',
  button: 'Registrarme',
  iHaveAnAccount: '¿Ya tienes usuario?',
  thenSignIn: 'Ingresa aquí',
  itsSimple: 'Registrarte no te tomará más de 1 minuto.',
  or: 'O ingresa tus datos',
  loginWithFacebook: 'Continúa con Facebook',
}


export const calendar = {
  whenDoWePickItUp: '¿Cuándo podemos pasar a retirar los ítems?',
  noAddressSelected: 'No hay dirección seleccionada',
  address: 'Dirección de retiro',
  newAddress: 'Crear nueva dirección',
  time: 'Seleccionar horario de retiro',
  prices: 'Costos de Almacenaje',
  continue: 'Continuar',
}

export const address = {
  completeAddress: 'Completá la dirección',
  noStreetNumber: 'Completá el número de la calle',
  noPostalCode: 'Completá el código postal',
  selectOneOfYourAddresses: 'Seleccioná una de tus direcciones',
  orAddANewAddress: 'O agregá una nueva dirección',
  addANewAddress: 'Agregá una nueva dirección',
  orSelectOneOfYourAddresses: 'O seleccioná una de tus direcciones',
}

export const paymentMethod = {
  actions: {
    numberInvalid: 'Número inválido',
    expiryInvalid: 'Fecha de vencimiento inválida',
    cvcInvalid: 'Código de seguridad inválido',
  },
  selectOneOfYourCards: 'Seleccioná una de tus tarjetas',
  orAddANewCard: 'O agregá una nueva tarjeta',
  addANewCard: 'Agregá una nueva tarjeta',
  orSelectOneOfYourCards: 'O seleccioná una de tus tarjetas',
}

export const review = {
  actions: {
    confirmSuccess: 'Operación realizada con éxito',
  },
  almostDone: '¡Casi terminamos!',
  comments: 'Comentarios',
  details: 'Detalles',
  payment: 'Pago',
  confirm: 'Confirmar',
  addYourAddress: 'Ingresá tu dirección',
  addYourCreditCard: 'Ingresá tu tarjeta de crédito',
  viewPrices: 'Ver Precios',
}

export const timeslot = {
  whenDoWePickItUp: '¿Cuándo lo pasamos a buscar a',
  changeAddress: 'Cambiar dirección',
  continue: 'Continuar',
  viewPrices: 'Ver Precios',
}



// WEBPACK FOOTER //
// ./src/sections/depositV2/text.js